// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SearchField Component Styles */

:root {
  /* SearchField Components */
  --scl--cms-components-searchField-border-color: #7D8187;
  --scl--cms-components-searchField-border-hover-color: var(--input-hover);
  --scl--cms-components-searchField-focus-color: #2388FF;
  --scl--cms-components-searchField-warning-color: #FFC18E;
  --scl--cms-components-searchField-error-color: #F8868A;
  --scl--cms-components-searchField-icon-color: #8A8B8F;
  --scl--cms-components-searchField-text-color: var(--input-hover);
  --scl--cms-components-searchField-label-color: #7D8187;
  --scl--cms-components-searchField-label-hover-color: #C9CACD;
  --scl--cms-components-searchField-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);

}

.scl--cms-components-searchField-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

.scl--cms-components-searchField-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: 32px;
  border: 1px solid var(--scl--cms-components-searchField-border-color);
  border-radius: 3px;
  cursor: text;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  background: transparent;
}


.scl--cms-components-searchField-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background: var(--scl--cms-components-searchField-focus-color);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused::after {
  opacity: 1;
}

.scl--cms-components-searchField-plate:hover:not(.scl--cms-components-searchField--focused) {
  border-color: var(--scl--cms-components-searchField-border-hover-color);
}

.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused {
  border-color: var(--scl--cms-components-searchField-border-hover-color);
}

.scl--cms-components-searchField-plate.scl--cms-components-searchField--warning::after {
  background: var(--scl--cms-components-searchField-warning-color);
  opacity: 1;
}

.scl--cms-components-searchField-plate.scl--cms-components-searchField--error::after {
  background: var(--scl--cms-components-searchField-error-color);
  opacity: 1;
}

.scl--cms-components-searchField-plate.scl--cms-components-searchField--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.scl--cms-components-searchField-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;
  gap: 8px;
  width: 100%;
  height: 32px;
  flex: 1;
  order: 0;
  flex-grow: 1;
  box-sizing: border-box;
}

/* Search Icon */
.scl--cms-components-searchField-icon {
  width: 16px;
  height: 16px;
  flex: none;
  order: 0;
  flex-grow: 0;
  flex-shrink: 0;
  color: var(--scl--cms-components-searchField-icon-color);
  transition: color 0.3s ease;
}

.scl--cms-components-searchField-plate:hover .scl--cms-components-searchField-icon,
.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused .scl--cms-components-searchField-icon {
  color: var(--scl--cms-components-searchField-icon-color);
}

/* Input Field */
.scl--cms-components-searchField-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.50px;
  caret-color: var(--input-defualt);
  
  color: var(--scl--cms-components-searchField-text-color);
  padding: 0;
  flex: 1;
  order: 1;
  flex-grow: 1;
}

.scl--cms-components-searchField-input::placeholder {
  color: transparent;
}

.scl--cms-components-searchField-input:disabled {
  cursor: not-allowed;
}

/* Floating Label */
.scl--cms-components-searchField-label {
  position: absolute;
  left: 32px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--input-defualt);
  background: transparent;
  padding: 0 4px;
  margin: 0 -4px;
  pointer-events: none;
  transition: all 0.2s ease;
  z-index: 1;
  opacity: 1;
}

/* Label position when focused (icon hidden) */
.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused .scl--cms-components-searchField-label:not(.scl--cms-components-searchField-label--floating) {
  left: 9px;
}

.scl--cms-components-searchField-label.scl--cms-components-searchField-label--floating {
  left: 12px;
  top: 0;
  transform: translateY(-50%);
  font-size: 12px;
  line-height: 14px;
  color: var(--input-hover);
  padding: 0 6px;
  margin: 0 -6px;
  background: transparent;
  position: absolute;
  z-index: 2;
}

.scl--cms-components-searchField-label.scl--cms-components-searchField-label--floating::before {
  content: "";
  position: absolute;
  left: 4px;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 3px;
  background: #F5F8FB;
  z-index: -1;
}

/* Hover effect on label */
.scl--cms-components-searchField-plate:hover:not(.scl--cms-components-searchField--focused) .scl--cms-components-searchField-label {
  color: var(--input-hover);
}

/* Error Text */
.scl--cms-components-searchField-errorText {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 4px 2px 14px;
  height: 16px;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: #FF5252;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/search-field-op/css/searchField.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,2BAA2B;EAC3B,uDAAuD;EACvD,wEAAwE;EACxE,sDAAsD;EACtD,wDAAwD;EACxD,sDAAsD;EACtD,qDAAqD;EACrD,gEAAgE;EAChE,sDAAsD;EACtD,4DAA4D;EAC5D,0HAA0H;;AAE5H;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qEAAqE;EACrE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,8DAA8D;EAC9D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,gEAAgE;EAChE,UAAU;AACZ;;AAEA;EACE,8DAA8D;EAC9D,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,iCAAiC;;EAEjC,wDAAwD;EACxD,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,MAAM;EACN,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":["/* SearchField Component Styles */\n\n:root {\n  /* SearchField Components */\n  --scl--cms-components-searchField-border-color: #7D8187;\n  --scl--cms-components-searchField-border-hover-color: var(--input-hover);\n  --scl--cms-components-searchField-focus-color: #2388FF;\n  --scl--cms-components-searchField-warning-color: #FFC18E;\n  --scl--cms-components-searchField-error-color: #F8868A;\n  --scl--cms-components-searchField-icon-color: #8A8B8F;\n  --scl--cms-components-searchField-text-color: var(--input-hover);\n  --scl--cms-components-searchField-label-color: #7D8187;\n  --scl--cms-components-searchField-label-hover-color: #C9CACD;\n  --scl--cms-components-searchField-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);\n\n}\n\n.scl--cms-components-searchField-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n.scl--cms-components-searchField-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  height: 32px;\n  border: 1px solid var(--scl--cms-components-searchField-border-color);\n  border-radius: 3px;\n  cursor: text;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  background: transparent;\n}\n\n\n.scl--cms-components-searchField-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  background: var(--scl--cms-components-searchField-focus-color);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused::after {\n  opacity: 1;\n}\n\n.scl--cms-components-searchField-plate:hover:not(.scl--cms-components-searchField--focused) {\n  border-color: var(--scl--cms-components-searchField-border-hover-color);\n}\n\n.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused {\n  border-color: var(--scl--cms-components-searchField-border-hover-color);\n}\n\n.scl--cms-components-searchField-plate.scl--cms-components-searchField--warning::after {\n  background: var(--scl--cms-components-searchField-warning-color);\n  opacity: 1;\n}\n\n.scl--cms-components-searchField-plate.scl--cms-components-searchField--error::after {\n  background: var(--scl--cms-components-searchField-error-color);\n  opacity: 1;\n}\n\n.scl--cms-components-searchField-plate.scl--cms-components-searchField--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.scl--cms-components-searchField-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 12px;\n  gap: 8px;\n  width: 100%;\n  height: 32px;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n/* Search Icon */\n.scl--cms-components-searchField-icon {\n  width: 16px;\n  height: 16px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  flex-shrink: 0;\n  color: var(--scl--cms-components-searchField-icon-color);\n  transition: color 0.3s ease;\n}\n\n.scl--cms-components-searchField-plate:hover .scl--cms-components-searchField-icon,\n.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused .scl--cms-components-searchField-icon {\n  color: var(--scl--cms-components-searchField-icon-color);\n}\n\n/* Input Field */\n.scl--cms-components-searchField-input {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.50px;\n  caret-color: var(--input-defualt);\n  \n  color: var(--scl--cms-components-searchField-text-color);\n  padding: 0;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n}\n\n.scl--cms-components-searchField-input::placeholder {\n  color: transparent;\n}\n\n.scl--cms-components-searchField-input:disabled {\n  cursor: not-allowed;\n}\n\n/* Floating Label */\n.scl--cms-components-searchField-label {\n  position: absolute;\n  left: 32px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: var(--input-defualt);\n  background: transparent;\n  padding: 0 4px;\n  margin: 0 -4px;\n  pointer-events: none;\n  transition: all 0.2s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n/* Label position when focused (icon hidden) */\n.scl--cms-components-searchField-plate.scl--cms-components-searchField--focused .scl--cms-components-searchField-label:not(.scl--cms-components-searchField-label--floating) {\n  left: 9px;\n}\n\n.scl--cms-components-searchField-label.scl--cms-components-searchField-label--floating {\n  left: 12px;\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--input-hover);\n  padding: 0 6px;\n  margin: 0 -6px;\n  background: transparent;\n  position: absolute;\n  z-index: 2;\n}\n\n.scl--cms-components-searchField-label.scl--cms-components-searchField-label--floating::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 3px;\n  background: #F5F8FB;\n  z-index: -1;\n}\n\n/* Hover effect on label */\n.scl--cms-components-searchField-plate:hover:not(.scl--cms-components-searchField--focused) .scl--cms-components-searchField-label {\n  color: var(--input-hover);\n}\n\n/* Error Text */\n.scl--cms-components-searchField-errorText {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 4px 2px 14px;\n  height: 16px;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: #FF5252;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
